import { Box, Button } from '@bpba/ui-components';
import { MarginProps, LayoutProps } from 'styled-system';

type StyledButtonProps = {
  children: React.ReactNode;
  onClick?: any;
} & LayoutProps &
  MarginProps;

export const StyledButton = (props: StyledButtonProps) => {
  return (
    <Box {...props}>
      <Button
        variant="primary"
        fontSize={'14px'}
        py={'14px !important'}
        px={'30px !important'}
        marginTop={'0px !important'}
        onClick={props.onClick}
      >
        {props.children}
      </Button>
    </Box>
  );
};
